import { UploadFileStatus } from '../interfaces/UploadFileStatus';
import { guid } from '@progress/kendo-react-common';
var ampRegExp = /&/g;
var ltRegExp = /</g;
var quoteRegExp = /"/g;
var aposRegExp = /'/g;
var gtRegExp = />/g;

var htmlEncode = function htmlEncode(value) {
  return ('' + value).replace(ampRegExp, '&amp;').replace(ltRegExp, '&lt;').replace(gtRegExp, '&gt;').replace(quoteRegExp, '&quot;').replace(aposRegExp, '&#39;');
};

var getFileExtension = function getFileExtension(fileName) {
  var rFileExtension = /\.([^\.]+)$/;
  var matches = fileName.match(rFileExtension);
  return matches ? matches[0] : '';
};

var getFileInfo = function getFileInfo(rawFile) {
  var fileName = rawFile.name;
  var fileSize = rawFile.size;
  return {
    extension: getFileExtension(fileName),
    name: htmlEncode(fileName),
    getRawFile: function getRawFile() {
      return rawFile;
    },
    size: fileSize,
    status: UploadFileStatus.Selected,
    progress: 0,
    uid: ''
  };
};

var getAllFileInfo = function getAllFileInfo(rawFiles) {
  var allFileInfo = new Array();
  var i;

  for (i = 0; i < rawFiles.length; i++) {
    allFileInfo.push(getFileInfo(rawFiles[i]));
  }

  return allFileInfo;
};

var fileHasValidationErrors = function fileHasValidationErrors(file) {
  if (file.validationErrors && file.validationErrors.length > 0) {
    return true;
  }

  return false;
};

var filesHaveValidationErrors = function filesHaveValidationErrors(files) {
  for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
    var file = files_1[_i];

    if (fileHasValidationErrors(file)) {
      return true;
    }
  }

  return false;
};

var getTotalFilesSizeMessage = function getTotalFilesSizeMessage(files) {
  var totalSize = 0;
  var i;

  if (typeof files[0].size === 'number') {
    for (i = 0; i < files.length; i++) {
      if (files[i].size) {
        totalSize += files[i].size || 0;
      }
    }
  } else {
    return '';
  }

  totalSize /= 1024;

  if (totalSize < 1024) {
    return totalSize.toFixed(2) + ' KB';
  } else {
    return (totalSize / 1024).toFixed(2) + ' MB';
  }
};

var assignGuidToFiles = function assignGuidToFiles(files, batchFiles) {
  var uid = guid();
  return files.map(function (file) {
    file.uid = batchFiles ? uid : guid();
    return file;
  });
};

export default {
  fileHasValidationErrors: fileHasValidationErrors,
  filesHaveValidationErrors: filesHaveValidationErrors,
  getTotalFilesSizeMessage: getTotalFilesSizeMessage,
  getAllFileInfo: getAllFileInfo,
  getFileInfo: getFileInfo,
  getFileExtension: getFileExtension,
  htmlEncode: htmlEncode,
  assignGuidToFiles: assignGuidToFiles
};